import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { startSpinner,finishSpinner } from "../ui/spinner";

export const feriadosTraerStart = () => ({ type: types.feriadosTraerStart });
export const feriadosLimpiar = () => ({ type: types.feriadosLimpiar });
export const feriadosTraerError = (error) => ({ type: types.feriadosTraerError, payload: error});
export const feriadosSeleccionar = (payload) => ({ type: types.feriadosSeleccionar, payload: payload});
export const feriadosEliminar = (payload) => ({ type: types.feriadosEliminar, payload: payload});
export const feriadosSetCentrosFeriados = (payload) => ({ type: types.feriadosSetCentrosFeriados, payload: payload});
export const feriadosTraerSuccess = (payload) => {
    return {
        type: types.feriadosTraerSuccess,
        payload: payload
    }
}

export const fetchFeriados = () => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(feriadosTraerStart());
        const response = await fetchConToken(`Feriados`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(feriadosTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const fetchFeriadosPorDescripcion = (descripcion) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(feriadosTraerStart());
        const response = await fetchConToken(`Feriados/traerPorDescripcion/${descripcion}`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch(feriadosTraerSuccess(lista));
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const fetchFeriadosPorCentro = (idCentroMedico) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(feriadosTraerStart());
      const response = await fetchConToken(`Feriados/traerPorCentro/${idCentroMedico}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(feriadosTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const agregarEditarFeriado = (fecha, idTipo, descripcion, idFeriado, callback) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      const response = await fetchConToken(`Feriados`, {fecha, idTipo, descripcion, idFeriado}, 'POST');
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const item = await response.json();
        if (response.status !== 200) throw item.errores;
        dispatch(feriadosSeleccionar(item));
        dispatch( startAlerta(`El feriado se ${idFeriado === 0 ? 'genero' : 'modifico'} correctamente`, "success", `Exito!`) );
        callback&& callback();
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const eliminarFeriado = (idFeriado) => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        const response = await fetchConToken(`Feriados`, {idFeriado}, 'DELETE');
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const item = await response.json();
          if (response.status !== 200) throw item.errores;
          dispatch( feriadosEliminar(idFeriado) );
          dispatch( startAlerta("El feriado se elimino correctamente", "success", `Exito!`) );
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
  };

export const setCentroFeriado = (idFeriado, idCentroMedico, callback) => {
    return async (dispatch, getState) => {
      try{
        dispatch(startSpinner());
        dispatch(feriadosTraerStart());
        const response = await fetchConToken(`feriadosCentros`, {idFeriado, idCentroMedico},'POST');
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const item = await response.json();
            if (response.status !== 200) throw item.errores;

            const state = getState();
            const { feriadosCentros: centrosActuales } = state.feriados.seleccionado;
            const nuevosCentros = centrosActuales ? [ ...centrosActuales, item ] : [ item ];

            dispatch( feriadosSetCentrosFeriados(nuevosCentros) );
            callback&& callback();
        }
        dispatch(finishSpinner());
      } catch (err){
          console.log( err );
          dispatch(finishSpinner());
          dispatch(startAlerta('No se pudo agregar el Centro Médico del Feriado', "warning", `¡Error!`));
      }
    };
};

export const eliminarCentroFeriado = (idFeriado, idCentroMedico) => {
    return async (dispatch, getState) => {
      try{
        dispatch(startSpinner());
        const response = await fetchConToken(`feriadosCentros`, {idFeriado, idCentroMedico},'DELETE');
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const item = await response.json();
            if (response.status !== 200) throw item.errores;

            const state = getState();
            const { feriadosCentros: centrosActuales } = state.feriados.seleccionado;
            const nuevosCentros = centrosActuales.filter(s => s.idCentro !== idCentroMedico );

            dispatch( feriadosSetCentrosFeriados(nuevosCentros) );
        }
        dispatch(finishSpinner());
      } catch (err){
          console.log( err );
          dispatch(finishSpinner());
          dispatch(startAlerta('No se pudo eliminar el Centro Médico del Feriado', "warning", `¡Error!`));
      }
    };
};